import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export function initTeamMarquee({
        sectionSelector = '.js-team-marquee, [data-parallax-columns]',
        columnSelector = '.js-marquee, [data-parallax-col], .team-col',
        contentSelector = '.js-marquee-content',
        minFillFactor = 1.5,
        basePercents = { from: [0, -10, -20], to: [-15, 0, -30] },
        scrubs= [1.2, 1.3, 1.25],
    } = {}) {

    const sections = document.querySelectorAll(sectionSelector);
    if (!sections.length) return;

    sections.forEach(section => {
        const cols = Array.from(section.querySelectorAll(columnSelector));
        if (!cols.length) return;

        ScrollTrigger.getAll().forEach(st => {
            if (section.contains(st.trigger)) st.kill();
        });

        cols.forEach((col, idx) => {
            let content = col.querySelector(contentSelector);
            if (!content) {
                content = document.createElement('div');
                content.className = contentSelector.replace('.', '');
                const cards = Array.from(col.children);
                cards.forEach(node => content.appendChild(node));
                col.appendChild(content);
            }

            const ensureFilled = () => {
                const containerH = section.clientHeight || col.clientHeight;
                const minTarget  = containerH * minFillFactor;

                col.querySelectorAll('[data-ghost="true"]').forEach(n => n.remove());

                let safety = 2;
                while (content.scrollHeight < minTarget && safety-- > 0) {
                    const clone = content.cloneNode(true);
                    clone.dataset.ghost = 'true';
                    clone.setAttribute('aria-hidden', 'true');
                    clone.style.pointerEvents = 'none';
                    col.appendChild(clone);
                }
            };

            ensureFilled();

            const from = basePercents.from[idx % basePercents.from.length];
            const to   = basePercents.to[idx % basePercents.to.length];
            const scrub = scrubs[idx % scrubs.length];

            gsap.fromTo(col, { yPercent: from }, {
                yPercent: to,
                ease: 'none',
                scrollTrigger: {
                    trigger: section,
                    start: 'top 95%',
                    end: 'bottom 5%',
                    scrub,
                    invalidateOnRefresh: true,
                }
            });

            const onRefresh = () => ensureFilled();
            ScrollTrigger.addEventListener('refreshInit', onRefresh);
            window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
        });
    });
}
